<template lang="html">
  <div class="cw-register">
    <div class="hero is-small has-text-centered is-bottom-paddingless">
      <div class="hero-body">
        <div class="has-text-grey-medium">
          <icon name="profile" scale="4" label="set"></icon>
        </div>
        <h1 class="title is-size-4">Register</h1>
        <div class="columns centerit">
          <div class="column is-two-thirds">
            <h3 class="subtitle is-size-5 is-marginless">
              Register to request company Team with CW, and sales will contact
              you to complete the process.
            </h3>
            <p class="is-size-6 has-text-grey-light">
              If your company already has a Team set up, you do not need to
              register. A coworker who has access must invite you to join.
            </p>
          </div>
        </div>
      </div>
    </div>
    <section class="section">
      <form class="form">
        <label class="label font-light">Company Information</label>
        <div class="field">
          <div class="control has-icons-left">
            <span class="icon is-left">
              <i class="las la-2x la-info-circle"></i>
            </span>
            <input
              class="input is-underlined is-medium"
              :class="{ 'is-danger': $v.company.$error }"
              type="text"
              placeholder="Company"
              v-model="company"
              @input="$v.company.$touch()"
              @focus="$v.company.$touch()"
            />
            <p class="help" v-if="$v.company.$dirty && !$v.company.required">
              This field is required.
            </p>
          </div>
        </div>
        <div class="field">
          <div class="control has-icons-left">
            <span class="icon is-left">
              <i class="las la-2x la-map-marker"></i>
            </span>
            <input
              class="input is-underlined is-medium"
              ref="addressInput"
              :class="{ 'is-danger': $v.street.$error }"
              type="text"
              placeholder="Street"
              v-model="street"
              @input="$v.street.$touch()"
              @focus="$v.street.$touch()"
            />
            <p class="help" v-if="$v.street.$dirty && !$v.street.required">
              This field is required.
            </p>
          </div>
        </div>

        <div class="field">
          <div class="control has-icons-left">
            <span class="icon is-left">
              <i class="las la-2x la-map-marker"></i>
            </span>
            <input
              class="input is-underlined is-medium"
              :class="{ 'is-danger': $v.city.$error }"
              type="text"
              placeholder="City, State"
              v-model="city"
              @input="$v.city.$touch()"
              @focus="$v.city.$touch()"
            />
            <p class="help" v-if="$v.city.$dirty && !$v.city.required">
              This field is required.
            </p>
          </div>
        </div>
        <div class="field">
          <div class="control has-icons-left">
            <span class="icon is-left">
              <i class="las la-2x la-map-marker"></i>
            </span>
            <input
              class="input is-underlined is-medium"
              :class="{ 'is-danger': $v.zipcode.$error }"
              type="text"
              placeholder="Zipcode"
              v-model="zipcode"
              @input="$v.zipcode.$touch()"
              @focus="$v.zipcode.$touch()"
            />
            <p class="help" v-if="$v.zipcode.$dirty && !$v.zipcode.required">
              This field is required.
            </p>
          </div>
        </div>

        <label class="label font-light">Contact Information</label>
        <div class="field">
          <div class="control has-icons-left">
            <span class="icon is-left">
              <i class="las la-2x la-male"></i>
            </span>
            <input
              class="input is-underlined is-medium"
              :class="{ 'is-danger': $v.name.$error }"
              type="text"
              placeholder="Name"
              v-model="name"
              @input="$v.name.$touch()"
              @focus="$v.name.$touch()"
            />
            <p class="help" v-if="$v.name.$dirty && !$v.name.required">
              This field is required.
            </p>
            <p class="help" v-if="!$v.name.minLength">
              Name must have at least
              {{ $v.name.$params.minLength.min }} letters
            </p>
          </div>
        </div>
        <div class="field">
          <div class="control has-icons-left">
            <span class="icon is-left">
              <i class="las la-2x la-envelope"></i>
            </span>
            <input
              class="input is-underlined is-medium"
              :class="{ 'is-danger': $v.email.$error }"
              type="email"
              placeholder="Email Address"
              v-model="email"
              @input="$v.email.$touch()"
              @focus="$v.email.$touch()"
            />
            <p class="help" v-if="$v.email.$dirty && !$v.email.required">
              This field is required.
            </p>
            <p class="help" v-if="!$v.email.email">
              Not a valid email address.
            </p>
          </div>
        </div>
        <div class="field">
          <div class="control has-icons-left">
            <span class="icon is-left">
              <i class="las la-2x la-phone"></i>
            </span>
            <cleave
              ref="phoneInput"
              class="input is-underlined is-medium"
              :class="{ 'is-danger': $v.phone.$error }"
              type="tel"
              :options="{ phone: true, phoneRegionCode: 'us' }"
              placeholder="Phone Number"
              v-model="phone"
              :events="{ onInput: $v.phone.$touch, onFocus: $v.phone.$touch }"
            />
            <p class="help" v-if="$v.phone.$dirty && !$v.phone.required">
              This field is required.
            </p>
            <p class="help" v-if="!$v.phone.minLength || !$v.phone.maxLength">
              Phone number must be in the format 555 555 1234
            </p>
          </div>
        </div>

        <label class="label font-light">Details</label>
        <div class="field">
          <div class="control">
            <textarea
              class="textarea is-medium"
              placeholder="Details"
              rows="6"
              v-model="details"
            ></textarea>
          </div>
        </div>
        <div class="field is-grouped is-grouped-right">
          <div class="control">
            <button
              class="button is-medium is-black is-rounded"
              type="button"
              name="button"
              @click="cancel"
            >
              Cancel
            </button>
          </div>
          <div class="control">
            <button
              class="button is-medium is-primary is-rounded"
              type="button"
              name="button"
              @click="submit"
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </section>
    <section class="section has-text-centered">
      <h3 class="title is-size-6">Have an account?</h3>
      <router-link
        to="/login"
        class="button is-medium is-black is-outlined is-rounded"
      >
        <span class="icon is-medium">
          <i class="las la-1x la-sign-in-alt"></i>
        </span>
        <span>Login</span>
      </router-link>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
let apiHost = process.env.VUE_APP_API_HOST;
import places from 'places.js';

// Validation helpers
import { validationMixin } from 'vuelidate';
import {
  required,
  minLength,
  maxLength,
  email,
} from 'vuelidate/lib/validators';

// Formatting during data entry
import Cleave from 'vue-cleave';
// Import us phone formatting
import 'cleave.js/dist/addons/cleave-phone.us';

export default {
  name: 'cw-register',
  mixins: [validationMixin],
  components: {
    Cleave,
  },
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      company: '',
      street: '',
      city: '',
      zipcode: '',
      details: '',
    };
  },
  validations: {
    name: {
      required,
      minLength: minLength(3),
    },
    email: {
      required,
      email,
    },
    phone: {
      required,
      // Include spaces in min and max length
      minLength: minLength(12),
      maxLength: maxLength(12),
    },
    company: {
      required,
    },
    street: {
      required,
    },
    city: {
      required,
    },
    zipcode: {
      required,
    },
  },
  computed: {
    address() {
      return `${this.street} ${this.city} ${this.zipcode}`;
    },
  },
  methods: {
    updateAddress(e) {
      this.street = e.suggestion.value || '';
      let city = e.suggestion.city || '';
      let state = e.suggestion.administrative || '';
      this.city = `${city}, ${state}`;
      this.zipcode = e.suggestion.postcode || '';
    },
    async submit() {
      // Validate Client side
      if (this.$v.$invalid) {
        this.$v.$touch();
        this.$modal.show('alert', {
          title: 'Insufficient Info',
          message:
            'Some of the fields are invalid. Please check that you have entered the required information.',
          type: 'warning',
        });
        return;
      }
      this.$modal.show('wifi-loader', { message: 'Processing...' });

      try {
        await axios.post(`${apiHost}/auth/register`, {
          name: this.name,
          email: this.email,
          phone: this.phone,
          company: this.company,
          address: this.address,
          details: this.details,
        });
        this.clear();
        this.$modal.hide('wifi-loader');
        this.$modal.show('alert', {
          title: 'Success',
          message:
            'Your registration information has been sent. You will be contacted soon about setting up an account.',
        });
        this.$router.push('/');
      } catch (err) {
        this.$modal.hide('wifi-loader');
        let res = err.response;
        if (res && res.data) {
          this.$modal.show('alert', {
            title: res.data.title,
            message: res.data.message,
            type: 'warning',
          });
        }
      }
    },
    clear() {
      this.name = '';
      this.email = '';
      this.phone = '';
      this.company = '';
      this.street = '';
      this.city = '';
      this.zipcode = '';
      this.details = '';
      this.$v.$reset();
    },
    cancel() {
      this.$modal.show('alert', {
        title: 'Are You Sure?',
        message:
          'Do you wish to cancel your registration and lose the information you have entered?',
        type: 'warning',
        actions: [
          {
            title: 'Yes',
            callback: () => {
              this.$modal.hide('alert');
              this.$router.push({ name: 'Home' });
            },
            classes: ['is-primary'],
          },
          {
            title: 'No',
            callback: () => {
              this.$modal.hide('alert');
            },
            classes: ['is-black'],
          },
        ],
      });
    },
  },
  mounted() {
    let input = places({
      container: this.$refs.addressInput,
      type: 'address',
      templates: {
        value: function(suggestion) {
          return suggestion.name;
        },
      },
    });
    input.on('change', this.updateAddress);

    this.$modal.show('alert', {
      title: 'Do Your Team Members use RED Mobile?',
      message:
        'You can skip registration! Ask someone to invite you via the app.',
    });
  },
};
</script>

<style lang="stylus" scoped></style>
